import React from 'react'
import type { ButtonDownloadOfflineProps } from './ButtonDownloadOffline.types'
import {
  ButtonDownload,
  Text,
  ContentButton
} from './ButtonDownloadOffline.styles'
import { useTranslation } from 'i18n'

const ButtonDownloadOffline: React.FC<ButtonDownloadOfflineProps> = ({
  slug,
  title,
  author,
  imageUrl,
  noBorder = false,
  hasText = false,
  contentType = 'book',
  onDownloadStart
}) => {
  const { t } = useTranslation()
  const isNativeApp =
    typeof window !== 'undefined' && !!window.ReactNativeWebView

  if (!isNativeApp) return null

  const isVideo = contentType === 'video'
  const messageType = isVideo ? 'download_video' : 'download_book'
  const label = isVideo ? t('Baixar vídeo') : t('Baixar livro')
  const sizeIcon = noBorder ? 'large' : 'xLarge'

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    e.preventDefault()

    try {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: messageType,
          data: {
            slug,
            title,
            author,
            imageUrl
          }
        })
      )
      onDownloadStart?.()
    } catch (error) {
      console.error('Error sending download message:', error)
    }
  }

  return (
    <ContentButton hasText={hasText} onClick={handleClick}>
      <ButtonDownload
        iconName="download"
        theme={{ type: 'secondary', size: sizeIcon }}
        noBorder={noBorder}
        aria-label={label}
      />
      {hasText && <Text>{label}</Text>}
    </ContentButton>
  )
}

export default ButtonDownloadOffline
